<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header align-items-center justify-content-between border-0">
        <h5 class="card-title font-bold">مدیرت ارزش بن</h5>
      </div>
      <div class="card-body">
        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          small
          v-if="items && items.length"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(value)="data">
            {{ data.item.value | price }}
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.date | Date }}
          </template>
          <template v-slot:cell(actions)="data">
            <button
              type="button"
              class="btn btn-sm btn-warning"
              @click="openEditModal(data.item)"
            >
              ویرایش
            </button>
          </template>
        </b-table>
        <div v-else class="alert alert-info">موردی یافت نشد</div>
      </div>
    </div>
    <AddBonModal @after-update="afterUpdate" />

    <b-modal
      id="edit_bon_modal"
      ref="editBonModal"
      title="ویرایش ارزش بن"
      ok-title="ذخیره"
      cancel-title="انصراف"
      @ok="submitEditValue"
    >
      <div class="form-group">
        <label>مقدار جدید</label>
        <b-form-input
          type="number"
          v-model="editForm.value"
          placeholder="مقدار جدید بن را وارد کنید"
        />
      </div>
    </b-modal>
  </main>
</template>
<script>
import BonSettingsImpl from "@@/core/pages/customerClub/clubSettings/bonSettings/BonSettingsImpl.js";
export default {
  extends: BonSettingsImpl,
};
</script>
